import { getDistance } from 'geolib';

const coordinateValue = (position, longName, shortName, privateName) => {
  const value = position?.[longName] ?? position?.[shortName] ?? position?.[privateName];
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const normalizePosition = (position) => {
  const latitude = coordinateValue(position, 'latitude', 'lat', '_lat');
  const longitude = coordinateValue(position, 'longitude', 'lng', '_long');

  if (latitude === null || longitude === null) return null;
  return { latitude, longitude };
};

export const calculateCourtDistanceInKm = (userPosition, courtPosition) => {
  const normalizedUserPosition = normalizePosition(userPosition);
  const normalizedCourtPosition = normalizePosition(courtPosition);

  if (!normalizedUserPosition || !normalizedCourtPosition) return null;

  try {
    return (getDistance(normalizedUserPosition, normalizedCourtPosition) / 1000).toFixed(2);
  } catch (error) {
    return null;
  }
};

export const addCourtDistances = (courts, userPosition) => courts.map((court) => ({
  ...court,
  distanceInKm: calculateCourtDistanceInKm(userPosition, court.sitePosition),
}));
